import { MissionsService } from './missions.service';

export default angular
  .module('sfMobile.services.missions', [
    'sfMobile.services.crud',
    'sfMobile.config.database',
    'sfMobile.constants.mission-preferences',
  ])
  .factory('missionsService', MissionsService).name;
